import { DirectiveOptions } from 'vue';

export const muDialogDrag: DirectiveOptions = {
  bind(el: any, binding: any, vnode: any, oldVnode: any) {
    if (!binding.value) return;
    // 弹框可拉伸最小宽高
    const minWidth = 200;
    const minHeight = 200;
    // 获取弹框头部（这部分可双击全屏）
    const dragDom = el.querySelector('.el-dialog') as HTMLElement;
    const dialogHeaderEl = el.querySelector('.el-dialog__header') as HTMLElement;
    dragDom.style.cssText += 'top:160px;transform:translateY(0);';
    dialogHeaderEl.style.cssText += ';cursor:move;';
    // 给弹窗加上overflow auto；不然缩小时框内的标签可能超出dialog；
    // dragDom.style.overflow = "auto";

    // 清除选择头部文字效果
    // dialogHeaderEl.onselectstart = new Function("return false");
    // 头部加上可拖动cursor
    // dialogHeaderEl.style.cursor = 'move';

    // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
    // const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null);

    dialogHeaderEl.onmousedown = (e) => {
      const disX = e.clientX - dialogHeaderEl.offsetLeft;
      const disY = e.clientY - dialogHeaderEl.offsetTop;

      const dragDomWidth = dragDom.offsetWidth;
      const dragDomHeight = dragDom.offsetHeight;

      const screenWidth = document.body.clientWidth;
      const screenHeight = document.body.clientHeight;

      const minDragDomLeft = dragDom.offsetLeft;
      const maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth;

      const minDragDomTop = dragDom.offsetTop;
      const maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomHeight;

      const styleLeftStr = getComputedStyle(dragDom)['left'];
      const styleTopStr = getComputedStyle(dragDom)['top'];
      if (!styleLeftStr || !styleTopStr) return;
      let styleLeft: number;
      let styleTop: number;

      // Format may be "##%" or "##px"
      if (styleLeftStr.includes('%')) {
        styleLeft = +document.body.clientWidth * (+styleLeftStr.replace(/%/g, '') / 100);
        styleTop = +document.body.clientHeight * (+styleTopStr.replace(/%/g, '') / 100);
      } else {
        styleLeft = +styleLeftStr.replace(/px/g, '');
        styleTop = +styleTopStr.replace(/px/g, '');
      }

      document.onmousemove = (e) => {
        let left = e.clientX - disX;
        let top = e.clientY - disY;

        // Handle edge cases
        if (-(left) > minDragDomLeft) {
          left = -minDragDomLeft;
        } else if (left > maxDragDomLeft) {
          left = maxDragDomLeft;
        }
        if (-(top) > minDragDomTop) {
          top = -minDragDomTop;
        } else if (top > maxDragDomTop) {
          top = maxDragDomTop;
        }

        // Move current element
        dragDom.style.cssText += `;left:${left + styleLeft}px;top:${top + styleTop}px;`;

        // Emit onDialogDrag event
        // See https://stackoverflow.com/questions/49264426/vuejs-custom-directive-emit-event
        if (vnode.componentInstance) {
          vnode.componentInstance.$emit('onDialogDrag');
        } else if (vnode.elm) {
          vnode.elm.dispatchEvent(new CustomEvent('onDialogDrag'));
        }
      };

      document.onmouseup = () => {
        document.onmousemove = null;
        document.onmouseup = null;
      }
    }
    // dragDom.onmousemove = function (e) {
    //   if (e.clientX > dragDom.offsetLeft + dragDom.clientWidth - 10 || dragDom.offsetLeft + 10 > e.clientX) {
    //     dragDom.style.cursor = 'w-resize';
    //   } else if (el.scrollTop + e.clientY > dragDom.offsetTop + dragDom.clientHeight - 10) {
    //     dragDom.style.cursor = 's-resize';
    //   } else {
    //     dragDom.style.cursor = 'default';
    //     dragDom.onmousedown = null;
    //   }
    //
    //   dragDom.onmousedown = (e) => {
    //     const clientX = e.clientX;
    //     const clientY = e.clientY;
    //     const elW = dragDom.clientWidth;
    //     const elH = dragDom.clientHeight;
    //     const EloffsetLeft = dragDom.offsetLeft;
    //     const EloffsetTop = dragDom.offsetTop;
    //     dragDom.style.userSelect = 'none';
    //     const ELscrollTop = el.scrollTop;
    //     // 判断点击的位置是不是为头部
    //     if (clientX > EloffsetLeft && clientX < EloffsetLeft + elW && clientY > EloffsetTop && clientY < EloffsetTop + 100) {
    //       // 如果是头部在此就不做任何动作，以上有绑定dialogHeaderEl.onmousedown = moveDown;
    //     } else {
    //       document.onmousemove = function (e) {
    //         e.preventDefault(); // 移动时禁用默认事件
    //         // 左侧鼠标拖拽位置
    //         if (clientX > EloffsetLeft && clientX < EloffsetLeft + 10) {
    //           // 往左拖拽
    //           if (clientX > e.clientX) {
    //             dragDom.style.width = elW + (clientX - e.clientX) * 2 + 'px';
    //           }
    //           // 往右拖拽
    //           if (clientX < e.clientX) {
    //             if (dragDom.clientWidth >= minWidth) {
    //               dragDom.style.width = elW - (e.clientX - clientX) * 2 + 'px';
    //             }
    //           }
    //         }
    //
    //         // 右侧鼠标拖拽位置
    //         if (clientX > EloffsetLeft + elW - 10 && clientX < EloffsetLeft + elW) {
    //           // 往左拖拽
    //           if (clientX > e.clientX) {
    //             if (dragDom.clientWidth >= minWidth) {
    //               dragDom.style.width = elW - (clientX - e.clientX) * 2 + 'px';
    //             }
    //           }
    //           // 往右拖拽
    //           if (clientX < e.clientX) {
    //             dragDom.style.width = elW + (e.clientX - clientX) * 2 + 'px';
    //           }
    //         }
    //
    //         // 底部鼠标拖拽位置
    //         if (ELscrollTop + clientY > EloffsetTop + elH - 20 && ELscrollTop + clientY < EloffsetTop + elH) {
    //           // 往上拖拽
    //           if (clientY > e.clientY) {
    //             if (dragDom.clientHeight >= minHeight) {
    //               dragDom.style.height = elH - (clientY - e.clientY) * 2 + 'px';
    //             }
    //           }
    //           // 往下拖拽
    //           if (clientY < e.clientY) {
    //             dragDom.style.height = elH + (e.clientY - clientY) * 2 + 'px';
    //           }
    //         }
    //       };
    //
    //       // 拉伸结束
    //       document.onmouseup = function (e) {
    //         document.onmousemove = null;
    //         document.onmouseup = null;
    //       };
    //     }
    //   }
    // }
  }
};
